
jQuery(function($) {


    /* checkbox */
    $(function(){
        var form_checkbox = $('.formfield--checkbox').find('input');
        form_checkbox.click(function(){
            if($(this).is(':checked')){
                $(this).parent().addClass('--checked');
            }else{
                $(this).parent().removeClass('--checked');
            }
        });
    });
    /* checkbox */


    /* checkbox CF7 */
    $(function(){
        var form_checkbox = $('.wpcf7-checkbox .wpcf7-list-item-label');
        form_checkbox.click(function(){
            if($(this).siblings('input').is(':checked')){
                $(this).removeClass('--checked');
                $(this).siblings('input').prop('checked', false);
            }else{
                $(this).addClass('--checked');
                $(this).siblings('input').prop('checked', true);
            }
        });
    });
    /* checkbox CF7 */


    /* radio */
    $(function(){
        var form_radio = $('.formfield--radio').find('input');
        form_radio.click(function(){
            console.log(this.checked);
            if($(this).is(':checked')){
                $(this).parents('.formfield__input').find('label').removeClass('--checked');
                $(this).parent().addClass('--checked');
            }
        });
    });
    /* radio */

    /* radio CF7 */
    $(function(){
        var form_radio = $('.wpcf7-radio .wpcf7-list-item-label');
        form_radio.click(function(){
            $(this).parents('.wpcf7-radio').find('.wpcf7-list-item-label').removeClass('--checked');
            $(this).parents('.wpcf7-radio').find('input').prop('checked', false);
            $(this).siblings('input').prop('checked', true);
            $(this).addClass('--checked');
        });
    });
    /* radio */


    /* accordionblock */
    $(function(){
        var accordion = $('.accordionblock');
        var toggle = accordion.find('.accordionblock__head');

        toggle.click(function(event){
            event.preventDefault();
            $(this).parents('.accordionblock').toggleClass('accordionblock--active');
            $(this).siblings().toggle();
            if($(this).attr('aria-expanded') === 'true'){
                $(this).attr('aria-expanded', 'false');
            }else{
                $(this).attr('aria-expanded', 'true');
            }
        });
    });



    $(function(){
        Fancybox.bind(".videoblock__video", {
            Html: {
                video: {
                    autoplay: true,
                    ratio: 16 / 9,
                },
            },
        });
    });
    


    /* modal */
    $(function(){
        var modal_launch = $('.modallaunch');
        var modalitem = $('.modalitem');
        var modalclose = $('.modalitem__close');

        modal_launch.click(function(event){
            event.preventDefault();
            var modal_id = $(this).data('modalid')
            modalitem.filter('[data-modalid="' + modal_id + '"]').addClass('modalitem--active');
        });
        modalclose.click(function(){
            modalitem.removeClass('modalitem--active');
        });
        $(window).click(function(event){
            if(event.target.className == "modalitem modalitem--active"){
                modalitem.removeClass('modalitem--active');
            };
        });
        $(document).keyup(function(event) {
            if (event.keyCode == 27) {
                $('.modalitem .modalitem--active').removeClass('modalitem--active');
            };
        });
    });


    /* CF7 Form redirect */
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        location = 'https://www.bonvillescourtcountrypark.co.uk/thank-you/';
    }, false );


    /* scroll to top */
    $(function(){
        $(".footer__scroll").click(function() {
            console.log('click');
            $("html, body").animate({
                scrollTop: 0
            }, 10);
            return false;
        });
    });

});